import { useEffect, useState } from "react";
import BasicOptometry from "./BasicOptometry";
import AdvancedOptometryAnamnesis from "./AdvancedOptometryAnamnesis";
import AdvancedOptometryRefractive from "./AdvancedOptometryRefractive";
import AdvancedOptometryOculomotor from "./AdvancedOptometryOculomotor";
import AdvancedOptometryBinocular from "./AdvancedOptometryBinocular";
import AdvancedOptometryAccommodative from "./AdvancedOptometryAccommodative";
import AdvancedOptometrySensory from "./AdvancedOptometrySensory";
import AdvancedOptometryEyeHealth from "./AdvancedOptometryEyeHealth";
import EyeSchema from "./EyeSchema";
import CoverTest from "./CoverTest";
import HessLancaster from "./HessLancaster";
import FileViewer from "./FileViewer";
import PopupMessage from "./PopupMessage";
import { post } from "../js/post";
import {
  userData,
  selectedOptic,
  binocularStructure,
  basicOptometry,
  testScheme,
  hessLancasterStructure,
  deviationFactor,
  validateOptometryData,
  validateAnamnesisData,
  validateRefractiveData,
  validateOculomotorData,
  validateBinocularData,
  validateAccommodativeData,
  validateSensoryData,
  validateEyeHealthData,
  numOptometriesStruct,
  formatValueUnit,
} from "../js/utils";
import "../css/OptometryScreen.css";
import moment from "moment";
import Diagnosis from "./Diagnosis";

export default function OptometryScreen(props) {
  const [activeTab, setActiveTab] = useState(props.tabId);
  const [eyeSchema, setEyeSchema] = useState(false);
  const [coverTest, setCoverTest] = useState(false);
  const [hessLancaster, setHessLancaster] = useState(false);
  const [diagnosisPanel, setDiagnosisPanel] = useState(false);
  const [popupQuestion, setPopupQuestion] = useState(null);
  const [currentBinocularEdit, setCurrentBinocularEdit] =
    useState(binocularStructure);
  const [currentBasicOptometryEdit, setCurrentBasicOptometryEdit] =
    useState(basicOptometry);
  const [updateOpt, setUpdateOpt] = useState(false);
  const [currentEyeSchemaEdit, setCurrentEyeSchemaEdit] = useState(testScheme);
  const [currentHessLancasterEdit, setCurrentHessLancasterEdit] = useState(
    hessLancasterStructure,
  );
  const [testHL, setTestHL] = useState(null);
  const [diagnosisValue, setDiagnosisValue] = useState("");
  const [numObservations, setNumObservations] = useState(0);
  const [numOptometries, setNumOptometries] = useState(numOptometriesStruct);
  const [numFiles, setNumFiles] = useState(0);

  const [lastVisitedId, setLastVisitedId] = useState({
    optometria: props.optIds.optometria,
    anamnesis: props.optIds.anamnesis,
    refractivo: props.optIds.refractivo,
    oculomotor: props.optIds.oculomotor,
    binocular: props.optIds.binocular,
    acomodativo: props.optIds.acomodativo,
    sensorial: props.optIds.sensorial,
    saludOcular: props.optIds.saludOcular,
  });

  let pendingChanges = {
    changes: false,
    dataToSave: null,
  };

  let setPendingChanges = (value) => {
    pendingChanges = value;
  };

  const copyCurrentBasicOptometryEdit = (e) => {
    setCurrentBasicOptometryEdit(e);
  };

  const copyCurrentBinocularEdit = (e) => {
    setCurrentBinocularEdit(e);
  };

  // console.log(">> pendingChanges: ", pendingChanges);

  async function checkActiveTabForSaving(f) {
    const data = pendingChanges.dataToSave;
    switch (activeTab) {
      case 0:
        // Optometría básica
        if (
          (data.optometrista !== "" || data.oftalmologo !== "") &&
          (validateOptometryData(data) ||
            data.esquema.lines.length > 0 ||
            props.numObservations > 0)
        ) {
          await saveBasicOptometry();
          f();
        } else {
          createPopupQuestion(
            `Debe seleccionar un optometrista o un oftalmólogo, rellenar al menos un campo de las secciones RX Nueva, SC, CC, DIP o Queratometría, añadir esquema o alguna observación.`,
            () => {
              removePopupQuestion();
            },
            null,
            "Entendido",
          );
        }
        break;
      case 1:
        // Anamnesis
        if (data.optometrista !== "" && validateAnamnesisData(data)) {
          await saveAnamnesis();
          f();
        } else {
          createPopupQuestion(
            `Debe seleccionar un optometrista y rellenar al menos un campo de la ficha.`,
            () => {
              removePopupQuestion();
            },
            null,
            "Entendido",
          );
        }
        break;
      case 2:
        // Refractivo
        if (data.optometrista !== "" && validateRefractiveData(data)) {
          await saveRefractive();
          f();
        } else {
          createPopupQuestion(
            `Debe seleccionar un optometrista y rellenar al menos un campo de la ficha.`,
            () => {
              removePopupQuestion();
            },
            null,
            "Entendido",
          );
        }
        break;
      case 3:
        // Oculomotor
        if (data.optometrista !== "" && validateOculomotorData(data)) {
          await saveOculomotor();
          f();
        } else {
          createPopupQuestion(
            `Debe seleccionar un optometrista y rellenar al menos un campo de la ficha.`,
            () => {
              removePopupQuestion();
            },
            null,
            "Entendido",
          );
        }
        break;
      case 4:
        // Binocular
        if (data.optometrista !== "" && validateBinocularData(data)) {
          await saveBinocular();
          f();
        } else {
          createPopupQuestion(
            `Debe seleccionar un optometrista y rellenar al menos un campo de la ficha.`,
            () => {
              removePopupQuestion();
            },
            null,
            "Entendido",
          );
        }
        break;
      case 5:
        // Acomodativo
        if (data.optometrista !== "" && validateAccommodativeData(data)) {
          await saveAccommodative();
          f();
        } else {
          createPopupQuestion(
            `Debe seleccionar un optometrista y rellenar al menos un campo de la ficha.`,
            () => {
              removePopupQuestion();
            },
            null,
            "Entendido",
          );
        }
        break;
      case 6:
        // Sensorial
        if (data.optometrista !== "" && validateSensoryData(data)) {
          await saveSensory();
          f();
        } else {
          createPopupQuestion(
            `Debe seleccionar un optometrista y rellenar al menos un campo de la ficha.`,
            () => {
              removePopupQuestion();
            },
            null,
            "Entendido",
          );
        }
        break;
      case 7:
        // Salud ocular
        if (data.optometrista !== "" && validateEyeHealthData(data)) {
          await saveEyeHealth();
          f();
        } else {
          createPopupQuestion(
            `Debe seleccionar un optometrista y rellenar al menos un campo de la ficha.`,
            () => {
              removePopupQuestion();
            },
            null,
            "Entendido",
          );
        }
        break;

      default:
        break;
    }
  }

  const handleTabClick = (index) => {
    // console.log("VEAMOS: ", pendingChanges, activeTab, index);
    if (pendingChanges.changes && activeTab !== index) {
      if (
        (activeTab === 0 && lastVisitedId.optometria === -1) ||
        (activeTab === 1 && lastVisitedId.anamnesis === -1) ||
        (activeTab === 2 && lastVisitedId.refractivo === -1) ||
        (activeTab === 3 && lastVisitedId.oculomotor === -1) ||
        (activeTab === 4 && lastVisitedId.binocular === -1) ||
        (activeTab === 5 && lastVisitedId.acomodativo === -1) ||
        (activeTab === 6 && lastVisitedId.sensorial === -1) ||
        (activeTab === 7 && lastVisitedId.saludOcular === -1)
      ) {
        createPopupQuestion(
          "Por favor, guarde o cancele la ficha que está creando.",
          async () => {
            removePopupQuestion();
          },
          null,
          "Entendido",
        );
      } else {
        createPopupQuestion(
          "Existen cambios que no han sido guardados. ¿Desea guardar antes de salir?",
          async () => {
            await checkActiveTabForSaving(() => {
              setActiveTab(index);
              removePopupQuestion();
            });
          },
          () => {
            setActiveTab(index);
            removePopupQuestion();
          },
        );
      }
    } else {
      setActiveTab(index);
    }
  };

  const createPopupQuestion = (
    text,
    onClickAccept,
    onClickCancel,
    textAccept,
    textCancel,
  ) => {
    setPopupQuestion({
      text,
      onClickCancel,
      onClickAccept,
      textAccept,
      textCancel,
    });
  };

  const checkChanges = (value) => {
    setPendingChanges(value);
  };

  const removePopupQuestion = () => {
    setPopupQuestion(null);
  };

  const getNumOptometries = async () => {
    const response = await post("ListarNumOptometrias.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idPaciente: props.patientInfo.id,
    });
    setNumOptometries(response);
    setLastVisitedId({
      optometria: response.optometria.id,
      anamnesis: response.anamnesis.id,
      refractivo: response.refractivo.id,
      oculomotor: response.oculomotor.id,
      binocular: response.binocular.id,
      acomodativo: response.acomodativo.id,
      sensorial: response.sensorial.id,
      saludOcular: response.saludOcular.id,
    });
  };

  const saveBasicOptometry = async () => {
    await post("GuardarOptometriaBasica.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idPaciente: props.patientInfo.id,
      ...pendingChanges.dataToSave,
      fecha_actualizacion: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
  };

  const saveAdvancedOptometry = async (phpFile) => {
    const requestData = {
      token: userData.token,
      optica: selectedOptic.id,
      ...pendingChanges.dataToSave,
    };
    await post(phpFile, requestData);
  };

  const saveAnamnesis = async () => {
    await saveAdvancedOptometry("GuardarAnamnesis.php");
  };

  const saveRefractive = async () => {
    await saveAdvancedOptometry("GuardarRefractivo.php");
  };

  const saveOculomotor = async () => {
    await saveAdvancedOptometry("GuardarOculomotor.php");
  };

  const saveBinocular = async () => {
    await saveAdvancedOptometry("GuardarBinocular.php");
  };

  const saveAccommodative = async () => {
    await saveAdvancedOptometry("GuardarAcomodativo.php");
  };

  const saveSensory = async () => {
    await saveAdvancedOptometry("GuardarSensorial.php");
  };

  const saveHessLancaster = async (sensoryId) => {
    const response = await post("GuardarHessLancaster.php", {
      token: userData.token,
      optica: selectedOptic.id,
      idSensorial: sensoryId,
      idHessLancaster: currentHessLancasterEdit.idHessLancaster,
      punto1_od_x: currentHessLancasterEdit.punto1_od_x - deviationFactor,
      punto1_od_y: currentHessLancasterEdit.punto1_od_y - deviationFactor,
      punto2_od_x: currentHessLancasterEdit.punto2_od_x - deviationFactor,
      punto2_od_y: currentHessLancasterEdit.punto2_od_y - deviationFactor,
      punto3_od_x: currentHessLancasterEdit.punto3_od_x - deviationFactor,
      punto3_od_y: currentHessLancasterEdit.punto3_od_y - deviationFactor,
      punto4_od_x: currentHessLancasterEdit.punto4_od_x - deviationFactor,
      punto4_od_y: currentHessLancasterEdit.punto4_od_y - deviationFactor,
      punto5_od_x: currentHessLancasterEdit.punto5_od_x - deviationFactor,
      punto5_od_y: currentHessLancasterEdit.punto5_od_y - deviationFactor,
      punto6_od_x: currentHessLancasterEdit.punto6_od_x - deviationFactor,
      punto6_od_y: currentHessLancasterEdit.punto6_od_y - deviationFactor,
      punto7_od_x: currentHessLancasterEdit.punto7_od_x - deviationFactor,
      punto7_od_y: currentHessLancasterEdit.punto7_od_y - deviationFactor,
      punto8_od_x: currentHessLancasterEdit.punto8_od_x - deviationFactor,
      punto8_od_y: currentHessLancasterEdit.punto8_od_y - deviationFactor,
      punto9_od_x: currentHessLancasterEdit.punto9_od_x - deviationFactor,
      punto9_od_y: currentHessLancasterEdit.punto9_od_y - deviationFactor,
      observaciones_od: currentHessLancasterEdit.observaciones_od,
      punto1_oi_x: currentHessLancasterEdit.punto1_oi_x - deviationFactor,
      punto1_oi_y: currentHessLancasterEdit.punto1_oi_y - deviationFactor,
      punto2_oi_x: currentHessLancasterEdit.punto2_oi_x - deviationFactor,
      punto2_oi_y: currentHessLancasterEdit.punto2_oi_y - deviationFactor,
      punto3_oi_x: currentHessLancasterEdit.punto3_oi_x - deviationFactor,
      punto3_oi_y: currentHessLancasterEdit.punto3_oi_y - deviationFactor,
      punto4_oi_x: currentHessLancasterEdit.punto4_oi_x - deviationFactor,
      punto4_oi_y: currentHessLancasterEdit.punto4_oi_y - deviationFactor,
      punto5_oi_x: currentHessLancasterEdit.punto5_oi_x - deviationFactor,
      punto5_oi_y: currentHessLancasterEdit.punto5_oi_y - deviationFactor,
      punto6_oi_x: currentHessLancasterEdit.punto6_oi_x - deviationFactor,
      punto6_oi_y: currentHessLancasterEdit.punto6_oi_y - deviationFactor,
      punto7_oi_x: currentHessLancasterEdit.punto7_oi_x - deviationFactor,
      punto7_oi_y: currentHessLancasterEdit.punto7_oi_y - deviationFactor,
      punto8_oi_x: currentHessLancasterEdit.punto8_oi_x - deviationFactor,
      punto8_oi_y: currentHessLancasterEdit.punto8_oi_y - deviationFactor,
      punto9_oi_x: currentHessLancasterEdit.punto9_oi_x - deviationFactor,
      punto9_oi_y: currentHessLancasterEdit.punto9_oi_y - deviationFactor,
      observaciones_oi: currentHessLancasterEdit.observaciones_oi,
    });
    setCurrentHessLancasterEdit({
      ...currentHessLancasterEdit,
      idHessLancaster: response.idHessLancaster,
    });
  };

  const saveEyeHealth = async () => {
    await saveAdvancedOptometry("GuardarSaludOcular.php");
  };

  const getActiveTabName = () => {
    const names = [
      "Optometría",
      "Anamnesis",
      "Refractivo",
      "Oculomotor",
      "Binocular",
      "Acomodativo",
      "Sensorial",
      "Salud ocular",
      "Ficheros",
    ];
    return names[activeTab];
  };

  const openDiagnosisPanel = (e) => {
    setDiagnosisValue(e);
    setDiagnosisPanel(true);
  };

  const closeDiagnosisPanel = () => {
    setDiagnosisPanel(false);
    setDiagnosisValue("");
  };

  const getObservations = async (optId) => {
    const response = await post("ListarObservaciones.php", {
      token: userData.token,
      optica: selectedOptic.id,
      id: optId,
      categoria: "OptometriaBasica",
    });
    setNumObservations(response.length);
  };

  let tabs = [
    {
      label: `Optometría (${formatValueUnit(numOptometries.optometria.num)})`,
      content: (
        <BasicOptometry
          toggleEyeSchema={async (basicOptometry) => {
            setEyeSchema(!eyeSchema);
            if (!eyeSchema) {
              copyCurrentBasicOptometryEdit(basicOptometry);
              if (
                JSON.stringify(currentEyeSchemaEdit) ===
                  JSON.stringify(testScheme) ||
                currentBasicOptometryEdit.idOptometria !==
                  basicOptometry.idOptometria
              ) {
                setCurrentEyeSchemaEdit(basicOptometry.esquema);
              }
            }
          }}
          patientId={props.patientInfo.id}
          optometryId={
            lastVisitedId.optometria
              ? lastVisitedId.optometria
              : props.optIds.optometria
          }
          saveLastOptIdVisited={async (id) => {
            setLastVisitedId((prevLastVisitedId) => ({
              ...prevLastVisitedId,
              optometria: id,
            }));
          }}
          createPopupQuestion={(
            text,
            onClickAccept,
            onClickCancel,
            textAccept,
            textCancel,
          ) =>
            createPopupQuestion(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            )
          }
          removePopupQuestion={() => {
            removePopupQuestion();
          }}
          pendingChanges={(value) => {
            checkChanges(value);
          }}
          updateTab={async () => {
            await getNumOptometries();
          }}
          updateOpt={updateOpt}
          updateOptAction={() => {
            setUpdateOpt(false);
          }}
          toggleObservationsPanel={(e, optId) => {
            if (e) {
              props.openObservationsPanel(
                props.patientInfo,
                optId,
                async () => {
                  await getObservations(optId);
                },
                "OptometriaBasica",
              );
            } else {
              props.closeObservationsPanel();
            }
          }}
          numObservations={numObservations}
        />
      ),
      icon:
        activeTab === 0
          ? "/images/optometry-white.svg"
          : "/images/optometry-blue.svg",
    },
    {
      label: `Anamnesis (${formatValueUnit(numOptometries.anamnesis.num)})`,
      content: (
        <AdvancedOptometryAnamnesis
          anamnesisId={lastVisitedId.anamnesis}
          patientId={props.patientInfo.id}
          createPopupQuestion={(
            text,
            onClickAccept,
            onClickCancel,
            textAccept,
            textCancel,
          ) =>
            createPopupQuestion(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            )
          }
          removePopupQuestion={() => {
            removePopupQuestion();
          }}
          saveLastAnamnesisIdVisited={(id) => {
            setLastVisitedId((prevLastVisitedId) => ({
              ...prevLastVisitedId,
              anamnesis: id,
            }));
          }}
          pendingChanges={(value) => {
            checkChanges(value);
          }}
          updateTab={async () => {
            await getNumOptometries();
          }}
          openDiagnosisPopup={(e) => {
            openDiagnosisPanel(e);
          }}
          closeDiagnosisPopup={() => {
            closeDiagnosisPanel();
          }}
          diagnosisValue={diagnosisValue}
        />
      ),
      icon:
        activeTab === 1
          ? "/images/anamnesis-white.svg"
          : "/images/anamnesis-blue.svg",
    },
    {
      label: `Refractivo (${formatValueUnit(numOptometries.refractivo.num)})`,
      content: (
        <AdvancedOptometryRefractive
          refractiveId={lastVisitedId.refractivo}
          patientId={props.patientInfo.id}
          createPopupQuestion={(
            text,
            onClickAccept,
            onClickCancel,
            textAccept,
            textCancel,
          ) =>
            createPopupQuestion(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            )
          }
          removePopupQuestion={() => {
            removePopupQuestion();
          }}
          saveLastRefractiveIdVisited={(id) => {
            setLastVisitedId((prevLastVisitedId) => ({
              ...prevLastVisitedId,
              refractivo: id,
            }));
          }}
          pendingChanges={(value) => {
            checkChanges(value);
          }}
          updateTab={async () => {
            await getNumOptometries();
          }}
          openDiagnosisPopup={(e) => {
            openDiagnosisPanel(e);
          }}
          closeDiagnosisPopup={() => {
            closeDiagnosisPanel();
          }}
          diagnosisValue={diagnosisValue}
        ></AdvancedOptometryRefractive>
      ),
      icon: activeTab === 2 ? "/images/rx-white.svg" : "/images/rx-blue.svg",
    },
    {
      label: `Oculomotor (${formatValueUnit(numOptometries.oculomotor.num)})`,
      content: (
        <AdvancedOptometryOculomotor
          oculomotorId={lastVisitedId.oculomotor}
          patientId={props.patientInfo.id}
          createPopupQuestion={(
            text,
            onClickAccept,
            onClickCancel,
            textAccept,
            textCancel,
          ) =>
            createPopupQuestion(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            )
          }
          removePopupQuestion={() => {
            removePopupQuestion();
          }}
          saveLastOculomotorIdVisited={(id) => {
            setLastVisitedId((prevLastVisitedId) => ({
              ...prevLastVisitedId,
              oculomotor: id,
            }));
          }}
          pendingChanges={(value) => {
            checkChanges(value);
          }}
          updateTab={async () => {
            await getNumOptometries();
          }}
          openDiagnosisPopup={(e) => {
            openDiagnosisPanel(e);
          }}
          closeDiagnosisPopup={() => {
            closeDiagnosisPanel();
          }}
          diagnosisValue={diagnosisValue}
        ></AdvancedOptometryOculomotor>
      ),
      icon:
        activeTab === 3
          ? "/images/accommodative-white.svg"
          : "/images/accommodative-blue.svg",
    },
    {
      label: `Binocular (${formatValueUnit(numOptometries.binocular.num)})`,
      content: (
        <AdvancedOptometryBinocular
          binocularId={lastVisitedId.binocular}
          currentBinocularEdit={currentBinocularEdit}
          toggleCoverTest={() => {
            setCoverTest(!coverTest);
          }}
          coverTest={coverTest}
          patientId={props.patientInfo.id}
          createPopupQuestion={(
            text,
            onClickAccept,
            onClickCancel,
            textAccept,
            textCancel,
          ) =>
            createPopupQuestion(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            )
          }
          removePopupQuestion={() => {
            removePopupQuestion();
          }}
          saveLastBinocularIdVisited={(id) => {
            setLastVisitedId((prevLastVisitedId) => ({
              ...prevLastVisitedId,
              binocular: id,
            }));
          }}
          pendingChanges={(value) => {
            checkChanges(value);
          }}
          updateTab={async () => {
            await getNumOptometries();
          }}
          onCoverTest={(e) => {
            copyCurrentBinocularEdit(e);
          }}
          openDiagnosisPopup={(e) => {
            openDiagnosisPanel(e);
          }}
          closeDiagnosisPopup={() => {
            closeDiagnosisPanel();
          }}
          diagnosisValue={diagnosisValue}
        ></AdvancedOptometryBinocular>
      ),
      icon:
        activeTab === 4
          ? "/images/binocular-white.svg"
          : "/images/binocular-blue.svg",
    },
    {
      label: `Acomodativo (${formatValueUnit(numOptometries.acomodativo.num)})`,
      content: (
        <AdvancedOptometryAccommodative
          accommodativeId={lastVisitedId.acomodativo}
          patientId={props.patientInfo.id}
          patientDateOfBirth={props.patientInfo.birthDate}
          createPopupQuestion={(
            text,
            onClickAccept,
            onClickCancel,
            textAccept,
            textCancel,
          ) =>
            createPopupQuestion(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            )
          }
          removePopupQuestion={() => {
            removePopupQuestion();
          }}
          saveLastAccommodativeIdVisited={(id) => {
            setLastVisitedId((prevLastVisitedId) => ({
              ...prevLastVisitedId,
              acomodativo: id,
            }));
          }}
          pendingChanges={(value) => {
            checkChanges(value);
          }}
          updateTab={async () => {
            await getNumOptometries();
          }}
          openDiagnosisPopup={(e) => {
            openDiagnosisPanel(e);
          }}
          closeDiagnosisPopup={() => {
            closeDiagnosisPanel();
          }}
          diagnosisValue={diagnosisValue}
        ></AdvancedOptometryAccommodative>
      ),
      icon:
        activeTab === 5
          ? "/images/accommodative-white.svg"
          : "/images/accommodative-blue.svg",
    },
    {
      label: `Sensorial (${formatValueUnit(numOptometries.sensorial.num)})`,
      content: (
        <AdvancedOptometrySensory
          sensoryId={lastVisitedId.sensorial}
          toggleHessLancaster={(hessLancasterData, e) => {
            setHessLancaster(!hessLancaster);
            if (
              !hessLancaster &&
              currentHessLancasterEdit.idHessLancaster === -1
            ) {
              setCurrentHessLancasterEdit(
                lastVisitedId.sensorial !== -1
                  ? hessLancasterData
                  : currentHessLancasterEdit,
              );
            }
            setTestHL(e);
          }}
          testHL={testHL}
          patientId={props.patientInfo.id}
          createPopupQuestion={(
            text,
            onClickAccept,
            onClickCancel,
            textAccept,
            textCancel,
          ) =>
            createPopupQuestion(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            )
          }
          removePopupQuestion={() => {
            removePopupQuestion();
          }}
          saveLastSensoryIdVisited={(id) => {
            setCurrentHessLancasterEdit(hessLancasterStructure);
            setLastVisitedId((prevLastVisitedId) => ({
              ...prevLastVisitedId,
              sensorial: id,
            }));
          }}
          pendingChanges={(value) => {
            checkChanges(value);
          }}
          updateTab={async () => {
            await getNumOptometries();
          }}
          saveHessLancaster={async (e) => {
            await saveHessLancaster(e);
          }}
          openDiagnosisPopup={(e) => {
            openDiagnosisPanel(e);
          }}
          closeDiagnosisPopup={() => {
            closeDiagnosisPanel();
          }}
          diagnosisValue={diagnosisValue}
        ></AdvancedOptometrySensory>
      ),
      icon:
        activeTab === 6
          ? "/images/sensory-white.svg"
          : "/images/sensory-blue.svg",
    },
    {
      label: `Salud ocular (${formatValueUnit(numOptometries.saludOcular.num)})`,
      content: (
        <AdvancedOptometryEyeHealth
          eyeHealthId={lastVisitedId.saludOcular}
          patientId={props.patientInfo.id}
          createPopupQuestion={(
            text,
            onClickAccept,
            onClickCancel,
            textAccept,
            textCancel,
          ) =>
            createPopupQuestion(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            )
          }
          removePopupQuestion={() => {
            removePopupQuestion();
          }}
          saveLastEyeHealthIdVisited={(id) => {
            setLastVisitedId((prevLastVisitedId) => ({
              ...prevLastVisitedId,
              saludOcular: id,
            }));
          }}
          pendingChanges={(value) => {
            checkChanges(value);
          }}
          updateTab={async () => {
            await getNumOptometries();
          }}
          openDiagnosisPopup={(e) => {
            openDiagnosisPanel(e);
          }}
          closeDiagnosisPopup={() => {
            closeDiagnosisPanel();
          }}
          diagnosisValue={diagnosisValue}
        ></AdvancedOptometryEyeHealth>
      ),
      icon:
        activeTab === 7
          ? "/images/eye-health-white.svg"
          : "/images/eye-health-blue.svg",
    },
    {
      label: `Ficheros (${formatValueUnit(numOptometries.ficheros)})`,
      content: (
        <FileViewer
          /* files={files} */
          category="Optometria"
          patientId={props.patientInfo.id}
          createPopupQuestion={(
            text,
            onClickAccept,
            onClickCancel,
            textAccept,
            textCancel,
          ) =>
            createPopupQuestion(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            )
          }
          removePopupQuestion={() => {
            removePopupQuestion();
          }}
          reloadFiles={async () => {
            await getNumOptometries();
          }}
        ></FileViewer>
      ),
      icon:
        activeTab === 8 ? "/images/files-white.svg" : "/images/files-blue.svg",
    },
  ];

  useEffect(() => {
    getNumOptometries();
  }, []);

  useEffect(() => {
    if (lastVisitedId.sensorial === -1) {
      setCurrentHessLancasterEdit(hessLancasterStructure);
    }
  }, [lastVisitedId.sensorial]);

  useEffect(() => {
    getObservations(lastVisitedId.optometria);
  }, [lastVisitedId.optometria]);

  return (
    <div className="popup-container" id="popup-optometry">
      {popupQuestion && (
        <PopupMessage
          text={popupQuestion.text}
          onClickCancel={popupQuestion.onClickCancel}
          onClickAccept={popupQuestion.onClickAccept}
          textAccept={popupQuestion.textAccept}
          textCancel={popupQuestion.textCancel}
        ></PopupMessage>
      )}
      <div className="popup-screen">
        <div className="popup-screen-header">
          <button
            className="popup-action-icon close-icon"
            onClick={async () => {
              if (pendingChanges.changes) {
                createPopupQuestion(
                  "Existen cambios que no han sido guardados. ¿Desea guardar antes de salir?",
                  async () => {
                    removePopupQuestion();
                    await checkActiveTabForSaving(props.onClose);
                  },
                  () => {
                    removePopupQuestion();
                    props.onClose();
                  },
                  "Sí",
                  "No",
                );
              } else {
                props.onClose();
              }
              await getNumOptometries();
            }}
          >
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
          <span className="popup-screen-header-title">
            {getActiveTabName()}
          </span>
        </div>
        <div className="store-tab-container">
          {tabs.map((tab, index) => (
            <div
              key={index}
              className={`store-tab ${
                index === activeTab ? "store-tab-selected" : ""
              }`}
              onClick={() => {
                handleTabClick(index);
              }}
            >
              <img
                src={tabs[index].icon}
                loading="lazy"
                alt="Icon"
                className="tab-icon"
              ></img>
              <span>{tab.label}</span>
              <div className="no-shadow-div"></div>
            </div>
          ))}
        </div>
        {tabs[activeTab].content}
        {eyeSchema && (
          <EyeSchema
            optometry={currentBasicOptometryEdit}
            eyeSchema={currentEyeSchemaEdit}
            updateEyeSchema={(eyeSchema) => {
              setCurrentEyeSchemaEdit(eyeSchema);
            }}
            onAccept={async (basicOptometry) => {
              if (
                basicOptometry.optometrista === "" &&
                basicOptometry.oftalmologo === ""
              ) {
                createPopupQuestion(
                  `Debe seleccionar un optometrista o un oftalmólogo.`,
                  async () => {
                    setEyeSchema(false);
                    removePopupQuestion();
                  },
                  null,
                );
              } else {
                if (!basicOptometry.idOptometria) {
                  basicOptometry.idOptometria = "-1";
                  basicOptometry.idPaciente = props.patientInfo.id;
                }
                const response = await post("GuardarOptometriaBasica.php", {
                  token: userData.token,
                  optica: selectedOptic.id,
                  ...basicOptometry,
                  fecha_actualizacion: moment().format("YYYY-MM-DD HH:mm:ss"),
                });
                setCurrentBasicOptometryEdit(basicOptometry);
                setEyeSchema(false);
                // Hay que guardar el id creado.
                setLastVisitedId((prevLastVisitedId) => ({
                  ...prevLastVisitedId,
                  optometria: response.idOptometria,
                }));
                //
                removePopupQuestion();
                createPopupQuestion(
                  `Los cambios se han guardado con éxito.`,
                  async () => {
                    setUpdateOpt(true);
                    setCurrentEyeSchemaEdit(testScheme);
                    removePopupQuestion();
                  },
                  null,
                  "Entendido",
                );
              }
            }}
            onCancel={() => {
              setEyeSchema(false);
            }}
          ></EyeSchema>
        )}
        {coverTest && (
          <CoverTest
            currentBinocular={currentBinocularEdit}
            onAccept={(e) => {
              // GUARDAR DATOS DE COVERTEST
              copyCurrentBinocularEdit(e);
              setCoverTest(false);
            }}
          ></CoverTest>
        )}
        {hessLancaster && (
          <HessLancaster
            data={currentHessLancasterEdit}
            test={testHL}
            onAccept={(e, t) => {
              setCurrentHessLancasterEdit(e);
              setTestHL(t);
              setHessLancaster(false);
            }}
            onCancel={() => {
              setHessLancaster(false);
            }}
            createPopupQuestion={(
              text,
              onClickAccept,
              onClickCancel,
              textAccept,
              textCancel,
            ) =>
              createPopupQuestion(
                text,
                onClickAccept,
                onClickCancel,
                textAccept,
                textCancel,
              )
            }
            removePopupQuestion={() => {
              removePopupQuestion();
            }}
          ></HessLancaster>
        )}
        {diagnosisPanel && (
          <Diagnosis
            value={diagnosisValue}
            onClose={() => {
              setDiagnosisPanel(false);
            }}
            onSave={(e) => {
              setDiagnosisValue(e);
            }}
          ></Diagnosis>
        )}
      </div>
    </div>
  );
}
